import { render, staticRenderFns } from "./AllGlLevel2.vue?vue&type=template&id=6703d9e2&"
import script from "./AllGlLevel2.vue?vue&type=script&lang=js&"
export * from "./AllGlLevel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports